import { Skeleton, Grid, Card, Typography, Box } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import { Chip } from "@mui/material";
import clsx from "clsx";
const useStyle = makeStyles((theme) => ({
  rsChipStyleMain: {
    border: "3 solid",
    fontSize: "10px !important",
    height: "60px !important",
    marginLeft: "3px !important",
    marginRight: "3px",
    marginTop: "30px",
    marginBottom: "30px",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "20px",
  },
  textMain: {
    paddingLeft: "20px",
  },
  rsIconMain: {
    fontSize: "35px !important",
  },
}));
/** default click function */
const defaultFunction = () => {};
/** default onchange function */
const defaultOnChange = () => {};
const CardDashbord = ({
  color = "rgba(107, 107, 107,0.6)",
  key,
  variant = "filled",
  borderColorChip = "rgba(107, 107, 107,0.6)",
  textColor = "white",
  border = "3",
  width = "auto",
  className,
  icon,
  title,
  variantText,
  titleColor,
  onChange = defaultOnChange,
  onClick = defaultFunction,
}) => {
  const classes = useStyle();
  return (
    <Card
      key={key}
      variant={variant}
      className={clsx(classes.rsChipStyleMain, className)}
      style={{
        background: color,
        borderColor: borderColorChip,
        color: textColor,
        border: border,
        width: width,
      }}
      onClick={(e) => onClick(e)}
      onChange={(e) => onChange(e)}
    >
      <Typography
        style={{ color: titleColor }}
        className={classes.textMain}
        variant={variantText}
      >
        {title}
      </Typography>
      <Box className={classes.rsIconMain}>{icon}</Box>
    </Card>
  );
};

export default CardDashbord;
